import update, { extend } from "immutability-helper";
import {
  CREATE_FORM_JSON,
  FormCreation,
  FormStack,
  SELECTED_FORM_ID,
  UPDATE_SELECTED_FORM_ID,
  REMOVE_ELEMENT,
  TRANSFER_ELEMENT_REFERENCE,
  SELECTED_DEVICETYPE,
  UPDATE_ELEMENT,
  REORDER_ELEMENT_REFERENCE,
  SET_GRID_SELECTION,
  UPDATE_GRID_STYLES,
  CLEAR_FORM_V2_JSON,
  INITIALIZE_FORM_V2_JSON,
  DELETE_BY_VALIDATION_KEY,
  SET_MODAL_VISIBILITY,
  UPDATE_MODAL_CONTENT,
  SET_SNACKBAR_VISIBILITY,
  UPDATE_CANVAS_CONFIG,
  SELECTED_DEVICE,
  CREATE_ASSET,
  DELETE_ASSET,
  SET_ASSET_EDIT_MODE,
  SET_ASSETS,
  DISCARD_ASSET_CHANGES,
  UNLINK_ASSET,
  UNDO,
  REDO,
  INITIALIZE_ACTION_STACK,
  PUSH_FORM_ACTION_STACK,
  UNDO_DELETE_ELEMENT,
  FormCreationData,
  UPDATE_TAB,
  UPDATE_SELECTED_ELEMENTS,
  CLEAR_SELECTED_ITEMS,
  PASTE_COPIED_ELEMENT,
  GROUP_ELEMENTS,
  UN_GROUP_ELEMENTS,
  FIXED_ELEMENTS_ARRAY,
  UPDATE_V2_FORM_PROPERTIES,
  ADD_COMPUTED_STYLES,
  ADD_CUSTOM_STYLE_URL,
  ADD_WRAPPER_COMPUTED_STYLES,
  COPY_STYLES,
  IS_V3_FORMS,
  DELETE_FIXED_ELEMENT,
  FIXED_ELEMENTS_ARRAY_V3,
  FIXED_ELEMENTS_ARRAY_UPDATE_V3,
  COPY_CANVAS_STYLES,
  UPDATE_TAB_ID,
  SAVE_FORM_JSON,
  UPDATE_STEPS_ORDER,
  UPDATE_PARENT_FIELDS,
  APPLY_STYLES
} from "./types";
import { getChildren, setValue, copyObj } from "../../../pages/apps/forms/formBuilder/helpers";
import { gridStyles, containers } from '../../../pages/apps/forms/formBuilder/constants'
import { getParentId } from "./reducer_helper";
import { components } from "../../../pages/apps/Assisted/forms/create/rendererJson";

const initialState: FormStack = {
  actionStack: [],
  actionPointer: 0,
  components: {},
  componentOrder: [],
  selectedElementId: "",
  newId: "",
  deviceType: "Sm",
  isGridSelected: true,
  isAssetInstanceSelected: false,
  gridStyles,
  modal: {
    visible: false,
    componentId: "",
  },
  snackbar: {
    visible: false,
    componentId: "",
  },
  canvasConfig: {
    onLoad: ''
  },
  assetEditMode: {
    isEnabled: false,
    assetId: "",
    asset: null,
  },
  assets: {},
  selectedElementsId: [],
  device: {
    name: "Iphone X",
    resolution: "375x812"
  },
  fixedArray: [],
  fixedArrayV3: {
    Sm: [],
    Md: [],
    Lg: [],
  },
  formProperties: {},
  isCoreV3: true,
  computedStyles:{},
  wrapperComputedStyles: {},
  styleUrl: {
    customCssUrl: '',
    globalCssUrl: '',
  },
};

/* 
 use this $mutateForm command if you want to update the 
 following fields
    - components
    - componentOrder
*/
extend('$mutateForm', function(mutation: any, formJson: FormStack) {
  const { assetId, isEnabled } = formJson.assetEditMode

  if(isEnabled && assetId) {
    return update(formJson, {
      assets: {
        [assetId]: {
          json: mutation
        }
      }
    })
  }

  return update(formJson, mutation)
})

export const formJsonReducer = (state: FormStack = initialState, action: FormCreation): FormStack => {
  switch (action.type) {
    case CREATE_FORM_JSON: {
      if (action.data.parentId) {
        return update(state, {
          $mutateForm: {
            components: {
              [action.data.id]: { $set: action.data },
              [action.data.parentId]: {
                fields: { $push: [action.data.id] },
              },
            },
            actionPointer: {
              $set: action.data.increment
                ? state.actionPointer + action.data.increment
                : state.actionPointer
            }
          }
        } as any);
      } else if (action.data.isAsset) {
        if (action.data.id) {
          return update(state, {
            $mutateForm: {
              components: {
                $merge: {
                  [action.data.id]: action.data
                }
              },
              componentOrder: { $push: [action.data.id] },
              actionPointer: {
                $set: action.data.increment
                  ? state.actionPointer + action.data.increment
                  : state.actionPointer
              }
            }
          } as any);
        } else {
          return update(state, {
            $mutateForm: {
              components: {
                $merge: {
                  ...action.data.components
                }
              }
            }
          } as any);
        }
      }

      return update(state, {
        $mutateForm: {
          components: {
            [action.data.id]: { $set: action.data },
          },
          componentOrder: { $push: [action.data.id] },
          actionPointer: {
            $set: action.data.increment
              ? state.actionPointer + action.data.increment
              : state.actionPointer
          }
        }
      } as any);
    }
    case SAVE_FORM_JSON: {
      let { components } = { ...state }
      if (action.data.id && action.data.id !== '') {
        return update(state, {
          components: {
            $set: {
              ...components,
              ...action.data.components
            }
          },
          componentOrder: { $push: [action.data.id] }
        })
      } else {
        return update(state, {
          components: {
            $set: {
              ...components,
              ...action.data.components
            }
          }
        })
      }
    }
    case UPDATE_PARENT_FIELDS: {
      let { parentId, id }: any = action.data
      return update(state, {
        $mutateForm: {
          components: {
            [parentId]: {
              fields: { $push: [id] },
            },
          }
        }
      } as any);
    }
    case UPDATE_STEPS_ORDER: {
      let {  selectedElementId, fields } = action.data
      let components = state.components
      components = {
        ...components,
        [selectedElementId] : {
          ...components[selectedElementId],
          fields: fields
        }
      }
      return {
        ...state,
        components: components
      }
    }
    case REMOVE_ELEMENT: {
      const { isEnabled, assetId } = state.assetEditMode
      const { id, parentId, type, increment } = action.data;
      // deleting the component source
      let components = { ...state.components };
      if(isEnabled && assetId) {
        components = { ...state.assets[assetId].json.components }
      }
      const fields = components[id].fields;
      delete components[id];

      // if the element being removed is capable of holding child items,
      // we need to delete those child items as well.
      if (containers.includes(type)) {
        const children = getChildren(fields, components)
        children.forEach((field) => delete components[field]);
      }

      // deleting the reference
      let componentOrder = [...state.componentOrder];
      if(isEnabled && assetId) {
        componentOrder = [...state.assets[assetId].json.componentOrder]
      }
      if (parentId) {
        components[parentId].fields = components[parentId].fields.filter(
          (field: string) => field !== id
        );
      } else {
        componentOrder = componentOrder.filter((el) => el !== id);
      }

      const newState = update(state, {
        $mutateForm: (current: any) => ({ 
          ...current, 
          components, 
          componentOrder, 
        })
      } as any)

      return { 
        ...newState, 
        selectedElementId: action.data.selectedElementId ? action.data.selectedElementId : '', 
        actionPointer: increment ? state.actionPointer + increment : state.actionPointer 
      }
    }
    case SELECTED_FORM_ID: {
      const { id, isAssetInstanceSelected, shouldSelectGrid } = action.data
      return update(state, {
        selectedElementId: { $set: id },
        isAssetInstanceSelected: { $set: Boolean(isAssetInstanceSelected) },
        isGridSelected: { $set: !!shouldSelectGrid },
      });
    }
    case UPDATE_SELECTED_FORM_ID: {
      const { isEnabled, assetId } = state.assetEditMode
      const { oldId, newId, increment } = action.data;
      let { components, componentOrder } = { ...state };
      if(isEnabled && assetId) {
        const assetJson = {...state.assets[assetId].json}
        components = assetJson.components
        componentOrder = assetJson.componentOrder
      }
      const deletedObject = { ...components[oldId] };
      deletedObject.id = newId;
      const fields = deletedObject.parentId ? components[deletedObject.parentId]?.fields || [] : componentOrder
      const oldIdIndex: number = fields.findIndex(componentId => componentId === oldId);
      if (oldIdIndex === -1) {
        return state;
      }
      delete components[oldId];
      fields.splice(oldIdIndex, 1, newId);
      
      // change the reference of child elements to the new ID
      if(deletedObject.fields) {
        deletedObject.fields.forEach(field => {
          const component = components[field]
          if(component) {
            component.parentId = newId
          }
        })
      }
      const newState = update(state, {
        $mutateForm: {
          components: {
            [newId]: { $set: deletedObject }
          },
          componentOrder: { $set: componentOrder },
        }
      } as any)

      return {
        ...newState,
        actionPointer: increment ? state.actionPointer + increment : state.actionPointer,
        selectedElementId:newId,
        modal: {
          ...newState.modal,
          componentId: (deletedObject.type === "CustomModal" || deletedObject.type === "A8Modal") ? newId : newState.modal.componentId
        },
        snackbar: {
          ...newState.snackbar,
          componentId: deletedObject.type === "SnackBar" ? newId : newState.snackbar.componentId
        },
      }
    }
    case TRANSFER_ELEMENT_REFERENCE: {
      const { isEnabled, assetId } = state.assetEditMode
      const { id, dropTargetId, dragSourceId, index, increment } = action.data
      let components = { ...state.components }
      let componentOrder = [...state.componentOrder]

      if (isEnabled && assetId) {
        const json = {...state.assets[assetId].json}
        components = json.components
        componentOrder = json.componentOrder
      }

      if (dropTargetId) {
        // If dropped area index is not provided, add to last, else insert at index
        if(index === undefined) {
          components[dropTargetId].fields = [...components[dropTargetId].fields, id]
        } else {
          const copy = [...components[dropTargetId].fields]
          copy.splice(index, 0, id)
          components[dropTargetId].fields = copy
        }
        components[id].parentId = dropTargetId
      } else {
        delete components[id].parentId
        // If dropped area index is not provided, add to last, else insert at index
        if(index === undefined) {
          componentOrder = [...componentOrder, id]
        } else {
          const copy = [...componentOrder]
          copy.splice(index, 0, id)
          componentOrder = copy
        }
      }
      if (dragSourceId) {
        components[dragSourceId].fields = components[dragSourceId].fields.filter((field: string) => field !== id)
      } else {
        componentOrder = componentOrder.filter(cmp => cmp !== id)
      }
      const newState =  update(state, {
        $mutateForm: (current: FormStack) => ({ ...current, components, componentOrder }),
      } as any);
      return {
        ...newState,
        actionPointer: increment === undefined ? state.actionPointer : state.actionPointer + increment
      }
    }
    case SELECTED_DEVICETYPE: {
      return update(state, {
        deviceType: { $set: action.data.devicetype }
      })
    }
    case SELECTED_DEVICE: {
      return update(state, {
        device: { $set: action.data.device }
      })
    }
    case UPDATE_ELEMENT: {
      const { assetId, isEnabled  } = state.assetEditMode
      const { id, path, value, increment } = action.data

      let components = copyObj(state.components)
      if(isEnabled && assetId) {
        components = copyObj(state.assets[assetId].json.components)
      }

      setValue(components[id], path.split("."), value, state.deviceType)

      const newState = update(state, {
        $mutateForm: {
          components: {
            $set: components,
          },
        }
      } as any)

      return {
        ...newState,
        actionPointer: increment === undefined ? state.actionPointer : state.actionPointer + increment
      }
    }
    case UPDATE_TAB:{
      const { id, field, value } = action.data
      const components = JSON.parse(JSON.stringify(state.components))
      setValue(components[id], field.split("."), value, state.deviceType)
      return{
        ...state,
        components
      }
      // setValue(components[id], path.split("."), value, state.deviceType)
    }
    case UPDATE_TAB_ID: {
      const { oldId, newId, increment } = action.data;
      let { components, componentOrder } = { ...state };
      const deletedObject = { ...components[oldId] };
      deletedObject.id = newId;
      const fields = deletedObject.parentId ? components[deletedObject.parentId]?.fields || [] : componentOrder
      const oldIdIndex: number = fields.findIndex(componentId => componentId === oldId);
      if (oldIdIndex === -1) {
        return state;
      }
      delete components[oldId];
      fields.splice(oldIdIndex, 1, newId);
      // change the reference of child elements to the new ID
      if(deletedObject.fields) {
        deletedObject.fields.forEach(field => {
          const component = components[field]
          if(component) {
            component.parentId = newId
          }
        })
      }
      const newState = update(state, {
        $mutateForm: {
          components: {
            [newId]: { $set: deletedObject }
          },
          componentOrder: { $set: componentOrder },
        }
      } as any)
      return {
        ...newState,
        actionPointer: increment ? state.actionPointer + increment : state.actionPointer,
        selectedElementId: deletedObject?.parentId || newId,
        newId: newId,
        modal: {
          ...newState.modal,
          componentId: (deletedObject.type === "CustomModal" || deletedObject.type === "A8Modal") ? newId : newState.modal.componentId
        },
        snackbar: {
          ...newState.snackbar,
          componentId: deletedObject.type === "SnackBar" ? newId : newState.snackbar.componentId
        },
      }
    }
    case UPDATE_GRID_STYLES: {
      const { path, value } = action.data
      const clonedGridStyles: any = JSON.parse(JSON.stringify(state.gridStyles))
      setValue(clonedGridStyles, path.split("."), value, state.deviceType)
      return {
        ...state,
        gridStyles: clonedGridStyles,
      }
    }
    case UPDATE_CANVAS_CONFIG: {
      return {
        ...state,
        canvasConfig: {
          ...state.canvasConfig,
          ...action.data
        },
      }
    }
    case REORDER_ELEMENT_REFERENCE: {
      const { dragSource, dropTarget, increment } = action.data;
      const splice: any = [
        [dragSource.index, 1],
        [dropTarget.index, 0, dragSource.id],
      ]
      // if the reordering takes place at the main canvas
      if (!dragSource.parentId && !dropTarget.parentId) {
        return update(state, {
          componentOrder: {
            $splice: splice
          },
          actionPointer: { $set: increment === undefined ? state.actionPointer : state.actionPointer + increment }
        });
      }
      // if the reordering takes place at a element capable of holding
      // child items
      if (dragSource.parentId === dropTarget.parentId) {
        const { parentId } = dragSource;
        return update(state, {
          $mutateForm: {
            components: {
              [parentId]: {
                fields: {
                  $splice: splice,
                },
              },
            },
            actionPointer: { $set: increment === undefined ? state.actionPointer : state.actionPointer + increment }
          }
        } as any);
      }
      return state;
    }
    case SET_GRID_SELECTION: {
      const { isGridSelected } = action.data
      return {
        ...state,
        isGridSelected,
        selectedElementId: isGridSelected ? "" : state.selectedElementId,
        isAssetInstanceSelected: isGridSelected ? false : state.isAssetInstanceSelected,
      }
    }
    case SET_MODAL_VISIBILITY: {
      return update(state, {
        modal: {
          $set: action.data.modal
        }
      })
    }
    case UPDATE_MODAL_CONTENT: {
      const { type, content, idx } = action.data
      const numIdx = Number(idx)

      const op = {
        $splice: type === 'DELETE' ? [[idx, 1]] : [[numIdx, 1], [numIdx, 0, content]],
        $push: [content]
      }

      const body: any = {}
      if(type === 'DELETE' || type === 'EDIT') {
        body['$splice'] = op['$splice']
      } else if(type === 'SET') {
        body['$push'] = op['$push']
      }

      return update(state, {
        $mutateForm: {
          components: {
            [state.selectedElementId]: {
              properties: {
                body
              }
            }
          }
        }
      } as any)
    }
    case DELETE_BY_VALIDATION_KEY: {
      const { selectedElementId, assetEditMode } = state;
      const { isEnabled, assetId } = assetEditMode
      const prop: any = action.data;

      let validation: any = {}
      if (isEnabled && assetId) {
        const components = state.assets[assetId].json.components;
        validation = components[selectedElementId].properties.validation;
      } else {
        validation = state.components[selectedElementId].properties.validation;
      }

      const { [prop]: val, ...newValidation } = validation;

      return update(state, {
        $mutateForm: {
          components: {
            [selectedElementId]: {
              properties: {
                validation: {
                  $set: newValidation,
                },
              },
            },
          },
        }
      } as any);
    }
    case SET_SNACKBAR_VISIBILITY: {
      return update(state, {
        snackbar: {
          $set: action.data.snackbar
        }
      })
    }
   case CREATE_ASSET: {
      const { asset, id } = action.data
      return update(state, {
        assetEditMode: {
          isEnabled: {
            $set: true,
          },
          assetId: {
            $set: id
          },
        },
        assets: {
          [id]: {
            $set: asset,
          }
        }
      })
    }
    case DELETE_ASSET: {
      const { id } = action.data
      const { [id]: val, ...newAssets } = state.assets;
      return update(state, {
        assets: {
          $set: newAssets
        }
      })
    }
    case SET_ASSET_EDIT_MODE: {
      const { isEnabled, assetId } = action.data 
      return update(state, {
        actionStack: {
          $set: [],
        },
        actionPointer: {
          $set: 0,
        },
        assetEditMode: {
          isEnabled: {
            $set: isEnabled
          },
          assetId: {
            $set: assetId
          },
          asset: {
            $set: (isEnabled && assetId) ? copyObj(state.assets[assetId]) : null
          },
        }
      })
    }
    case DISCARD_ASSET_CHANGES: {
      const { asset, assetId } = state.assetEditMode
      return update(state, {
        assets: {
          [assetId]: {
            $set: asset === null ? state.assets[assetId] : asset
          }
        },
        actionStack: {
          $set: [],
        },
        actionPointer: {
          $set: 0,
        },
        assetEditMode: {
          isEnabled: {
            $set: false
          },
          assetId: {
            $set: ""
          },
          asset: {
            $set: null
          }
        }
      })
    }
    case SET_ASSETS: {
      return update(state, {
        assets: {
          $set: action.data
        }
      })
    }
    case UNLINK_ASSET: {
      const { unlinkedComponents } = action.data;
      const components = {
        ...state.components,
        ...unlinkedComponents,
      };
      return update(state, {
        components: {
          $set: components,
        }
      })
    }
    case CLEAR_FORM_V2_JSON: {
      return initialState
    }
    case INITIALIZE_FORM_V2_JSON: {
      return {
        ...initialState,
        ...action.data,
      }
    }
    // Undo Redo
    case INITIALIZE_ACTION_STACK:
      return {
        ...state,
        actionPointer: 0,
        actionStack: [],
      };
    case PUSH_FORM_ACTION_STACK:
      const actionStackCopy = [...state.actionStack];
      actionStackCopy.splice(
        state.actionPointer,
        actionStackCopy.length,
        action.data
      );
      return update(state, {
        actionPointer: { $set: actionStackCopy.length },
        actionStack: { $set: actionStackCopy },
      });
    case UNDO:
      return {
        ...state,
        actionPointer: state.actionPointer - 1,
      };
    case REDO:
      return {
        ...state,
        actionPointer: state.actionPointer + 1,
      };
    case UNDO_DELETE_ELEMENT: {
      const { children, id, parentId, order, metadata } = action.data;
      const { components, componentOrder } = { ...state };

      if (parentId) {
        components[parentId].fields.splice(metadata.position, 0, id)
      } else {
        const index = order.indexOf(id);
        componentOrder.splice(index, 0, id)
      }
      delete action.data.metadata
      if (parentId) {
        let updatedState = update(state, {
          components: {
            [id]: { $set: action.data },
            [parentId]: {
              fields: { $set: components[parentId].fields },
            },
          },
          actionPointer: { $set: state.actionPointer - 1 }
        });
        children.forEach((child: FormCreationData) => {
          updatedState = update(updatedState, {
            components: {
              [child.id]: { $set: child }
            },
          })
        });
        return updatedState;
      }

      let modifiedState = update(state, {
        components: {
          [action.data.id]: { $set: action.data },
        },
        componentOrder: { $set: componentOrder },
        actionPointer: { $set: state.actionPointer - 1 }
      });
      children.forEach((child: FormCreationData) => {
        modifiedState = update(modifiedState, {
          components: {
            [child.id]: { $set: child }
          },
          componentOrder: { $set: componentOrder }
        })
      });
      return modifiedState;
    }
    // CONTEXT MENU HANDLERS
    case UPDATE_SELECTED_ELEMENTS:
      const { isEnabled, assetId } = state.assetEditMode;
      let originalComponent = { ...state.components }
      if(isEnabled && assetId) {
        const assetJson = {...state.assets[assetId].json}
        originalComponent = assetJson.components
      }
      let existingItems = [...state.selectedElementsId];
      if (!existingItems.includes(state.selectedElementId)) {
        existingItems.push(state.selectedElementId)
      }

      const commonParent = originalComponent[existingItems[0]]?.parentId
      const selectedItemParent = getParentId(originalComponent, action.data)
          
      if (commonParent === selectedItemParent && !existingItems.includes(action.data)) {
        existingItems.push(action.data)
      }else {
        existingItems = []
      }
      return update(state, {
        selectedElementsId: {
          $set: existingItems
        }
      })
    case CLEAR_SELECTED_ITEMS:
      return {
        ...state,
        selectedElementsId: [],
      }
    case PASTE_COPIED_ELEMENT: {
      const { isEnabled, assetId } = state.assetEditMode
      const { rootId, increment } = action.data;
      let { components, componentOrder } = { ...state }
      if(isEnabled && assetId) {
        const assetJson = {...state.assets[assetId].json}
        components = assetJson.components
        componentOrder = assetJson.componentOrder
      }
      const rootElement = action.data.components[rootId]
      const { parentId } = rootElement

      // Grid, ExpansionPanel, Row, Column
      if (parentId && components[parentId]) {
        components[parentId].fields = components[parentId].fields.concat([rootId])
      }

      if (!parentId) {
        componentOrder = componentOrder.concat([rootId])
      }

      return update(state, {
        $mutateForm: {
          componentOrder: {
            $set: componentOrder,
          },
          components: {
            $set: {
              ...components,
              ...action.data.components
            }
          },
          actionPointer: { $set: increment ? state.actionPointer + increment : state.actionPointer }
        }
      } as any)
    }
    case GROUP_ELEMENTS: {
      const { isEnabled, assetId } = state.assetEditMode
      const { grid, parentId } = action.data
      const selectedElementsId = state.selectedElementsId
      let components = { ...state.components }
      let componentOrder = [...state.componentOrder]
      if(isEnabled && assetId) {
        const assetJson = {...state.assets[assetId].json}
        components = assetJson.components
        componentOrder = assetJson.componentOrder
      }

      // change the parentId reference
      for (let id of selectedElementsId) {
        const component = components[id]
        component.parentId = grid.id
      }

      // remove the child references from the parent
      if (parentId) {
        components[parentId].fields = components[parentId].fields.concat([grid.id]).filter(item => !selectedElementsId.includes(item))
      } else {
        componentOrder = componentOrder.concat([grid.id]).filter(item => !selectedElementsId.includes(item))
      }

      components[grid.id] = { ...grid, parentId: parentId }

      const updatedState = update(state, {
        $mutateForm: {
          components: { $set: components },
          componentOrder: { $set: componentOrder },
        }
      } as any)
      return updatedState
    }
    case FIXED_ELEMENTS_ARRAY:{
      return {
        ...state,
        fixedArray: action.data?.fixedArray || []
      }
    }

    case FIXED_ELEMENTS_ARRAY_V3: {
      return {
        ...state,
        fixedArrayV3: {
          ...state.fixedArrayV3,
          [state.deviceType]: action.data?.fixedArray || [],
        },
      };
    }

    case DELETE_FIXED_ELEMENT: {
      const { selectedElementId } = action.data || {};
      if (selectedElementId) {
        const updatedFixedArray = { ...state.fixedArrayV3 };
        Object.keys(updatedFixedArray).forEach(deviceType => {
          updatedFixedArray[deviceType] = updatedFixedArray[deviceType].filter((ele: string) => ele !== selectedElementId);
        });
        return {
          ...state,
          fixedArrayV3: updatedFixedArray,
        };
      }
      return state;
    }

    case FIXED_ELEMENTS_ARRAY_UPDATE_V3: {
      return {
        ...state,
        fixedArrayV3: action.data?.fixedArray || []
      };
    }

    case UN_GROUP_ELEMENTS: {
      const { isEnabled, assetId } = state.assetEditMode
      const { grid } = action.data;
      let components = { ...state.components }
      let componentOrder = [...state.componentOrder]
      if(isEnabled && assetId) {
        const assetJson = {...state.assets[assetId].json}
        components = assetJson.components
        componentOrder = assetJson.componentOrder
      }
      let updatedState: any;

      if (grid.parentId) {
        // Nest the grid inside the parent
        const parentGroup = components[grid.parentId]
        const filteredData = components[grid.parentId].fields.filter(item => item !== grid.id)
        components[grid.parentId].fields = [...filteredData, ...grid.fields]
        delete components[grid.id]

        components[grid.parentId].fields.forEach((key: string | number) => {
          components[key].parentId = parentGroup.id
        });

        updatedState = update(state, {
          $mutateForm: {
            components: { $set: components },
          }
        } as any)
      } else {
        // Top level group elements
        const fields = components[grid.id].fields;
        delete components[grid.id]
        componentOrder = componentOrder.filter((el) => el !== grid.id)
        // Remove the parentId reference for childs
        if (grid.id) {
          fields.forEach((field) =>
            delete components[field].parentId
          )
          componentOrder = componentOrder.concat([...fields])
        }

        updatedState = update(state, {
          $mutateForm: {
            components: { $set: components },
            componentOrder: { $set: componentOrder },
          }
        } as any)
      }
      return updatedState
    }
    case UPDATE_V2_FORM_PROPERTIES: {
      return update(state, {
        formProperties: {
          $set: action.data
        }
      })
    }

    case IS_V3_FORMS: {
      return update(state, {
        isCoreV3: {
          $set: action.data
        }
      })
    }
    case ADD_COMPUTED_STYLES: {
      return update(state, {
        computedStyles: {
          $set: action.data
        }
      })
    }
    case ADD_WRAPPER_COMPUTED_STYLES: {
      return update(state, {
        wrapperComputedStyles: {
          $set: action.data
        }
      })
    }
    case ADD_CUSTOM_STYLE_URL: {
      const { customCssUrl, globalCssUrl } = action.data;
      return {
        ...state,
        styleUrl: {
          customCssUrl: customCssUrl !== undefined ? customCssUrl : state.styleUrl.customCssUrl,
          globalCssUrl: globalCssUrl !== undefined ? globalCssUrl : state.styleUrl.globalCssUrl,
        },
      };
    }
    case COPY_STYLES:
      const updatedComponentsCopyStyles = { ...state.components };
      action.data.componentIds.forEach((componentId: string) => {
        updatedComponentsCopyStyles[componentId] = {
          ...state.components[componentId],
          properties: {
            ...state.components[componentId].properties,
            styles: {
              ...state.components[componentId].properties.styles,
              [action.data.toDeviceType]: {
                ...state.components[componentId].properties.styles[action.data.fromDeviceType],
              },
            },
          },
        };
      });

      return {
        ...state,
        components: updatedComponentsCopyStyles,
      };
    case COPY_CANVAS_STYLES:
      const { fromDeviceType, toDeviceType } = action.data;
      const updatedCanvasCopyStyles: any = { ...state.gridStyles };
      updatedCanvasCopyStyles[toDeviceType] = { ...updatedCanvasCopyStyles[fromDeviceType] };
      return {
        ...state,
        gridStyles: updatedCanvasCopyStyles,
      };
    case APPLY_STYLES: {
      const { isEnabled, assetId } = state.assetEditMode
      const { rootId, increment } = action.data;
      let { components, componentOrder } = { ...state }

      if(isEnabled && assetId) {
        const assetJson = {...state.assets[assetId].json}
        components = assetJson.components
        componentOrder = assetJson.componentOrder
      }
      return update(state, {
        $mutateForm: {
          componentOrder: {
            $set: componentOrder,
          },
          components: {
            $set: {
              ...components,
              ...action.data.components
            }
          },
          actionPointer: { $set: increment ? state.actionPointer + increment : state.actionPointer }
        }
      } as any)
      }
    default:
      return state;
  }
};
